import Vue from 'vue';
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import ABaseComponent from "Components/Base/ABaseComponent";
import { CreatePorterItemCommandArguments, DeletePorterItemCommandArguments, PorterKey, PorterItemKey } from "Api/CoreApi";

import porterBuilder from 'Store/porterbuilder/porterbuilder';
import { textChangeRangeIsUnchanged } from 'typescript';
import productList from 'Store/productList/productList';

export enum AddToPorterState {
    None = 0,
    Adding = 2,
    Added = 3,
    Error = 4
}

@Component({
    template: "#add-to-porter-field-template"
})
export default class AddToPorterFieldsComponent extends ABaseComponent {

    @Prop({default:""})
    itemName: string;

    @Prop({default:""})
    itemNo: string;
    @Prop({default:""})
    languageId: string;
    @Prop()
    allowAdd : boolean;
    get porterBuilder(){
        return porterBuilder.state;
    }
    @Prop({default:false})
    oldModelSelectionSales : boolean;

    porterItemKey:string;
    state = AddToPorterState.None;
    variantExists = false;
    showOldModelModal : boolean = false;
    created() {
        this.setLoaded();
        this.loadPorterState();
        this.loadVariantExists();   
    }

    @Watch("porterBuilder.porterItems")
    loadPorterState(): void {
        // if(this.porterBuilder.porter){
        //     porterBuilder.dispatchLoadPorterItems(this.languageId).then(() => this.setLoaded()).catch(e => this.setError(e));
        // }½
        const exists = this.porterBuilder.porterItems.porterItems.find(item => item.porterItem.itemNo === this.itemNo);
        if (exists) {
            this.porterItemKey = exists.porterItem.id;
            this.state = AddToPorterState.Added;
        } else {
            this.state = AddToPorterState.None;
        }
    }
    @Watch("porterBuilder.porterItems")
    loadVariantExists(): void {
        if(!this.porterBuilder.porterItems.porterItems.find(item => item.product.productName === this.itemName)){
            this.variantExists = false;
        } else {
            this.variantExists = true;
        }
    }
    isNumOldModelSales(productnumber:string) : boolean{
     
        if(productList.state.productListPage.Products && productList.state.productListPage.Products.some(x=>x.Product.Number==productnumber)){
            return true;
        }
        return false;

    }   

    toggleOldModelModal() {
        if(this.showOldModelModal){
            this.showOldModelModal = false;
        }else{
            this.showOldModelModal = true;
        }
      
        // $.fancybox.open({
        //     src: "#confirm-multiple-sizes-modal"
        // });
        // porterBuilder.commitSetModalItemNumber(this.itemNo);
    }

    toggleModal() {
        $.fancybox.open({
            src: "#confirm-multiple-sizes-modal"
        });
        porterBuilder.commitSetModalItemNumber(this.itemNo);
    }

    createPorterItem() {
    
        if (this.variantExists) {
            this.toggleModal();
            return;
        }

        this.state = AddToPorterState.Adding;
        const args = new CreatePorterItemCommandArguments({
            porterKey: new PorterKey({
                id: this.porterBuilder.porterId
            }),
            comment: "",
            itemNo: this.itemNo
        });
        porterBuilder.dispatchCreatePorterItem(args).then(() =>{
            this.setLoaded();
            this.state = AddToPorterState.Added;
        }).catch(e => {
            this.setError(e);
            this.state = AddToPorterState.Error;
        });
    }
    deletePorterItem() {
        if (!this.porterItemKey) {
            this.setError("No ItemKey");
            return;
        }

        this.setLoading();
        this.state = AddToPorterState.Adding;

        const args = new DeletePorterItemCommandArguments({
            key: new PorterItemKey({
                id: this.porterItemKey
            })
        });
        porterBuilder.dispatchDeletePorterItem(args).then(() => {
            this.state = AddToPorterState.None;
            this.setLoaded();
        });
        let matchingItem =productList.state.productListPage.Products.find(x=>x.Product.Number == this.itemNo)
        if(matchingItem){
             
            matchingItem.Product.IsOldModelSales  = this.oldModelSelectionSales;
        }
       
    }
}

Vue.component("add-to-porter-field",AddToPorterFieldsComponent);